import BillingPricingInterval from "./pricing/interval"
import BillingPricingSlider from "./pricing/slider"
import BillingPricingPlanGroup from "./pricing/planGroup"
import BillingPricingPlan from "./pricing/plan"

const selector = "[data-billing-pricing]"
const initAttr = "_billing_pricing_initialized"

class BillingPricing {
  static init() {
    document.querySelectorAll(selector).forEach((element) => {
      new this(element)
    })
  }

  constructor(element) {
    this.element = element

    if (!this.element[initAttr]) {
      this.init()
    }
  }

  init() {
    this.initIntervals()
    this.initSlider()
    this.initPlanGroups()
    this.initPlans()

    if (!this.valid()) {
      throw new Error("billing pricing is invalid")
    }
    this.element[initAttr] = true
  }

  valid() {
    return this.interval.valid() &&
      this.slider.valid() &&
      this.planGroup.valid() &&
      this.plan.valid()
  }

  initIntervals() {
    const intervals = BillingPricingInterval.init(this)
    this.interval = intervals.find(interval => interval.selected)
  }

  initSlider() {
    this.slider = BillingPricingSlider.init(this)
  }

  initPlanGroups() {
    const planGroups = BillingPricingPlanGroup.init(this)

    this.planGroups = {}
    planGroups.forEach((planGroup) => {
      this.planGroups[planGroup.id] = planGroup
      if (planGroup.selected) {
        this.planGroup = planGroup
      }
    })
  }

  initPlans() {
    const plans = BillingPricingPlan.init(this)

    this.plans = {}
    plans.forEach((plan) => {
      this.plans[plan.id] = plan
      if (plan.selected) {
        this.plan = plan
      }
    })
  }

  setInterval(interval) {
    if (this.interval === interval) {
      return
    }

    this.interval.unselect()
    this.interval = interval
    this.interval.select()

    this.updatePlanGroup()
    this.updatePlan()
  }

  pageLimitChanged() {
    this.updatePlanGroup()
    this.updatePlan()
  }

  updatePlanGroup() {
    const planGroup = this.planGroups[this.currentPlanGroupId]
    this.setPlanGroup(planGroup)
  }

  setPlanGroup(planGroup) {
    if (this.planGroup === planGroup) {
      return
    }

    this.planGroup.hide()
    this.planGroup = planGroup
    this.planGroup.show()
  }

  updatePlan() {
    const plan = this.plans[this.currentPlanId]
    this.setPlan(plan)
  }

  setPlan(plan) {
    if (this.plan === plan) {
      return
    }

    this.plan.unselect()
    this.plan = plan
    this.plan.select()
  }

  get currentPlanGroupId() {
    return [
      this.slider.pageLimit,
      this.interval.value
    ].join("-")
  }

  get currentPlanId() {
    return [
      this.slider.pageLimit,
      this.plan.recurring,
      this.interval.value
    ].join("-")
  }
}

document.addEventListener("DOMContentLoaded", (event) => BillingPricing.init())
